import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

import Loader from "./layouts/Loader";
import "../styles/Bookmark.css";

function Bookmarks() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(0);
    const [refetch, setRefetch] = useState(0);

    async function fetch() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("time_zone", timeZone);
            formData.append("page", page);
            formData.append("type", "job");

            const response = await axios.post(
                baseUrl + "/api/bookmarks/fetch",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setData(response.data.bookmarks);
                setPages(response.data.pages);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    async function removeFromBookmark(id) {
        try {
            const formData = new FormData();
            formData.append("id", id);

            const response = await axios.post(
                baseUrl + "/api/bookmarks/remove",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const temp = [ ...data ];
                for (let a = 0; a < temp.length; a++) {
                    if (temp[a].id == id) {
                        temp.splice(a, 1);
                        break;
                    }
                }
                setData(temp);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        }
    }

    useEffect(function () {
        fetch();
    }, [refetch]);

    const styles = {
        profileImage: {
            width: "50px",
            marginRight: "10px"
        }
    };

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Bookmarks</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Bookmarks</li>
                        </ol>
                    </nav>
                </div>
            </div>
            
            <div className="container-xxl py-0 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="blogs">
                                { data.map(function (d) {
                                    return (
                                        <div className="blog-card" key={ `bookmark-${ d.id }` }>
                                            <button type="button" className="unbookmark-btn"
                                                onClick={ function () {
                                                    removeFromBookmark(d.id);
                                                } }>
                                                <i className="fas fa-heart"></i>
                                            </button>

                                            <h2 className="blog-title">{ d.job?.title }</h2>

                                            <div className="mb-3">
                                                { d.job?.company?.profile_image && (
                                                    <img src={ d.job?.company?.profile_image }
                                                        style={ styles.profileImage } />
                                                ) }
                                                
                                                <span className="blog-summary">{ d.job?.company?.name }</span>
                                            </div>

                                            <Link to={ `/jobs/${ d.job?.id }` } className="read-more">Read More →</Link>
                                        </div>
                                    );
                                }) }
                            </div>

                            { loading && (
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <Loader />
                                    </div>
                                </div>
                            ) }

                            { pages > 1 && (
                                <nav className="mt-3">
                                    <ul className="pagination">
                                        { Array.from({ length: pages }, function (_, index) { return index + 1 } ).map(function (p) {
                                            return (
                                                <li key={ `pagination-${ p }` } className={ `page-item ${ p == page ? "active" : "" }` }>
                                                    <a href="#" onClick={ function (event) {
                                                        event.preventDefault();
                                                        setPage(p);
                                                        setRefetch(refetch + 1);
                                                    } } className="page-link">{ p }</a>
                                                </li>
                                            );
                                        }) }
                                    </ul>
                                </nav>
                            ) }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Bookmarks;